module.exports = __webpack_public_path__ + "static/img/ball8.1c0e837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ball8.png
// module id = uiNM
// module chunks = 1